/* LRC viewed-products tracker.
   Records {handle, variant_id} for every product view into localStorage.
   Variant changes are caught by wrapping history.pushState/replaceState, so
   this works regardless of how the buy box rewrites ?variant=. */
(function () {
  var KEY = 'lrc_viewed_v1', MAX = 20;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }
  function record() {
    try {
      var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
      if (!m) return;
      var handle = m[1];
      var vid = '';
      try { vid = new URLSearchParams(location.search).get('variant') || ''; } catch (e) {}
      if (!vid) return;
      var list = read().filter(function (e) {
        return !(e.handle === handle && String(e.variant_id) === String(vid));
      });
      list.unshift({ handle: handle, variant_id: String(vid), ts: Date.now() });
      write(list);
    } catch (e) {}
  }

  record();
  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = history[fn];
    if (typeof orig !== 'function') return;
    history[fn] = function () {
      var r = orig.apply(this, arguments);
      try { record(); } catch (e) {}
      return r;
    };
  });
  window.addEventListener('popstate', record);

  window.LRC_VIEWED = {
    list: read,
    record: record,
    clear: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };
})();
